import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import EmailActionPopoverStats from 'automation-ui-action-features/actions/email/EmailActionPopoverStats';
export default {
  [ActionTypes.EMAIL]: EmailActionPopoverStats
};